<template>
  <div v-if="hasData" class="card shadow-sm">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">{{ $t("alarm.timeline.camera") }}:</span>
              <span class="info-value info-word-break">{{ item.data.camera }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t("alarm.timeline.server") }}:</span>
              <span class="info-value info-word-break">{{ item.data.server }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t("alarm.timeline.category") }}:</span>
              <span class="info-value">{{ item.data.alarm_category }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t("alarm.timeline.alarm_type") }}:</span>
              <span class="info-value">{{ item.data.type_alarm }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t("alarm.timeline.priority") }}:</span>
              <span class="info-value">{{ item.data.priority }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 d-flex align-items-center" v-if="item.data.image">
          <img
            :src="item.data.image"
            alt="Analytic Record Event"
            class="img-fluid timeline-image"
            @click="openImageModal(item.data.image)"
            v-b-modal.image_modal
          />
        </div>
      </div>
      <div v-if="item.data.matched_rules" class="mt-1 alert alert-warning mb-0">
        <strong>{{ $t("alarm.timeline.matched_rules") }}:</strong>
        {{ item.data.matched_rules }}
      </div>
      <div v-if="item.to && item.total" class="mt-1 alert alert-info mb-0">
        <small>
          <strong>{{
            $t("alarm.timeline.record_info", { to: item.to, total: item.total })
          }}</strong>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "AnalyticRecordItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const hasData = computed(() => {
      return props.item?.data && Object.keys(props.item.data).length > 0;
    });

    const openImageModal = async (imageUrl) => {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    };

    return {
      hasData,
      openImageModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #f1f1f1;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.info-value {
  text-align: right;
  flex-grow: 1;
  padding-left: 1rem;
}

.info-word-break {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  max-width: 100%;
}

.timeline-image {
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
  max-height: 220px;
  object-fit: cover;
  width: 100%;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.timeline-image:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.alert {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .info-value {
    text-align: left;
    padding-left: 0;
  }

  .timeline-image {
    margin-top: 1rem;
    max-height: 180px;
  }
}
</style>
